/**
 * Owns the item-picker UI for a loyalty reward form.
 * Coordinates the search input, the hidden item_id
 * field, and the chip that shows the currently
 * selected item.
 *
 * Reacts to reward_type and venue_id changes by
 * clearing the selection when it no longer applies.
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "search",
    "input",
    "selected",
    "selectedName",
    "rewardType",
    "venueId",
  ];

  connect() {
    this.syncMode();
  }

  select(event) {
    event.preventDefault();
    const { id, name } = event.params;
    if (!id) return;

    this.inputTarget.value = id;
    this.selectedNameTarget.textContent = name;
    this.showChip();
  }

  clear(event) {
    if (event) event.preventDefault();
    this.inputTarget.value = "";
    this.selectedNameTarget.textContent = "";
    this.showSearch();
  }

  rewardTypeChanged() {
    this.clear();
    this.syncMode();
    this.refreshSearch();
  }

  venueChanged() {
    this.clear();
    this.refreshSearch();
  }

  syncMode() {
    if (this.inputTarget.value) {
      this.showChip();
    } else {
      this.showSearch();
    }
  }

  showSearch() {
    this.searchTarget.classList.remove("hidden");
    this.selectedTarget.classList.add("hidden");
  }

  showChip() {
    this.searchTarget.classList.add("hidden");
    this.selectedTarget.classList.remove("hidden");
  }

  refreshSearch() {
    const searchController =
      this.application.getControllerForElementAndIdentifier(
        this.searchTarget,
        "loyalty-reward-item-search"
      );
    if (searchController) {
      searchController.refresh();
    }
  }
}
